import { render, staticRenderFns } from "./detail_orgStructure.vue?vue&type=template&id=760b4432&scoped=true&"
import script from "./detail_orgStructure.vue?vue&type=script&lang=js&"
export * from "./detail_orgStructure.vue?vue&type=script&lang=js&"
import style0 from "./detail_orgStructure.vue?vue&type=style&index=0&id=760b4432&prod&lang=css&"
import style1 from "./detail_orgStructure.vue?vue&type=style&index=1&id=760b4432&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760b4432",
  null
  
)

export default component.exports